import constants from '../../settings/constants';
import { Screensaver } from './screensaverTypes';

const defaultState: Screensaver = {
  mode: constants.SCREENSAVER_MODE.idle,
};

export default defaultState;
